import { render, staticRenderFns } from "./ModalAdicionarOuEditarPalavraBloqueada.vue?vue&type=template&id=694f1b6b&scoped=true"
import script from "./ModalAdicionarOuEditarPalavraBloqueada.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarOuEditarPalavraBloqueada.vue?vue&type=script&lang=js"
import style0 from "./ModalAdicionarOuEditarPalavraBloqueada.vue?vue&type=style&index=0&id=694f1b6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694f1b6b",
  null
  
)

export default component.exports